﻿import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from "react";
import { IDoesFilterPassParams, IFilterParams } from "@ag-grid-community/core";
import { Box, Select } from "@chakra-ui/react";
import { CandidateStatus } from "../../../../api/models/EntityCandidate";
import { getCandidateStatusTitle } from "../../../../components/CandidateStatus";

const CandidateStatusFilter = forwardRef((props: IFilterParams<{ status: CandidateStatus }>, ref) => {
    const [filterValue, setFilterValue] = useState<CandidateStatus | undefined>();

    const filterOptions = useMemo(
        () =>
            Object.keys(CandidateStatus)
                .map(value => value as CandidateStatus)
                .map(status => (
                    <option key={status} value={status}>
                        {getCandidateStatusTitle(status)}
                    </option>
                )),
        []
    );

    useImperativeHandle(ref, () => {
        return {
            doesFilterPass(params: IDoesFilterPassParams<{ status: CandidateStatus }>) {
                if (filterValue === undefined) {
                    return true;
                }
                return params.data.status === filterValue;
            },

            isFilterActive() {
                return filterValue !== undefined;
            },

            getModel() {
                if (!this.isFilterActive()) {
                    return null;
                }
                return { filterType: "text", type: "equals", filter: filterValue };
            },

            setModel(model: any) {
                const value = model == null ? undefined : model.filter || model.value;
                if (value !== filterValue) {
                    setFilterValue(value);
                }
            },
        };
    });

    useEffect(() => {
        props.filterChangedCallback();
    }, [filterValue]);

    return (
        <Box p={2}>
            <Select
                size="sm"
                value={filterValue ?? ""}
                onChange={event => {
                    const val = event.target.value;
                    setFilterValue(val === "" ? undefined : (val as CandidateStatus));
                }}
            >
                <option value="">All</option>
                {filterOptions}
            </Select>
        </Box>
    );
});

export default CandidateStatusFilter;
